<template>
  <div>
    <v-dialog
      v-model="dialog"
      width="900"
      max-width="800"
      v-on:click:outside="closeDialog()"
      v-on:keydown.esc="closeDialog()"
    >
      <v-card
        elevation="0"
        style="border-top: 10px solid #095797"
      >
        <v-card-title style="font-size:17px">
          {{ $t("Paiement.retirerListeAttente.avertissement") }}
        </v-card-title>
        <div>
          <p class="nomCoursDialoguesPageConfirmation">{{ cours.titre }}</p>
        </div>

        <!-- Boutons -->
        <div
          :class="ajustementBoutons()"
          style="display:flex"
        >
          <v-spacer style="width:50%"></v-spacer>
          <div
            class="text-right mt-5"
            style="padding-right:10px"
            :class="flexSurMobile()"
          >
            <v-btn
              outlined
              v-on:click="closeDialog()"
              :disabled="retraitListeAttenteEnCours"
              class="mb-3 btnRetraitOuAnnulation longueurBoutonPageConfirmation"
            >{{ $t("dialogInscription.btnAnnuler") }}</v-btn>
            <v-btn
              v-on:click="retirerListeAttente()"
              :loading="retraitListeAttenteEnCours"
              class="mb-3 ml-4 stylesBtnConfirmation longueurBoutonPageConfirmation"
            >{{ $t("Paiement.annulation.continuer") }}</v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import usePaiementStore from '@/store/paiementStore';

export default {
  name: 'RetirerListeAttenteDialog',
  setup() {
    const paiementStore = usePaiementStore();

    return { paiementStore };
  },
  data() {
    return {
      dialog: false,
      estMobile: false,
      cours: {},
      retraitListeAttenteEnCours: false,
    };
  },
  computed: {
  },
  created() {
    if (window.screen.width <= 760) {
      this.estMobile = true;
    } else {
      this.estMobile = false;
    }
  },
  methods: {
    ouvrirDialog(cours) {
      this.cours = cours; // Affectation du cours choisi dans le dialogue de retrait
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    },
    async retirerListeAttente() {
      this.retraitListeAttenteEnCours = true;
      await this.paiementStore.effectuerRemboursementPartiel({ coursEleveId: this.cours.coursEleveId }).finally(() => {
        // Loading arrête puisque la requête est finie
        this.retraitListeAttenteEnCours = false;
      });

      this.closeDialog();
    },
    flexSurMobile() {
      if (this.estMobile) {
        return 'flex';
      }
      return '';
    },
    ajustementBoutons() {
      if (this.estMobile) {
        return 'ajustementBoutonsDialoguesMobile';
      }
      return 'mx-10';
    },
  },
};
</script>

<style scoped>
.flex {
  display: flex;
}
</style>
